export default "/assets/images/pretend-im-not-even-here.d8695e8d3834b351.webp";